
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { SearchInput } from './SearchInput';
import { SearchResults } from './SearchResults';
import { BikeActionControls } from './BikeActionControls';
import { useDebounce } from '@/hooks/useDebounce';
import { Bike } from '@/services/types';

interface QuickBikeBlockDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const QuickBikeBlockDialog: React.FC<QuickBikeBlockDialogProps> = ({ 
  open, 
  onOpenChange 
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedBike, setSelectedBike] = useState<Bike | null>(null);
  const debouncedQuery = useDebounce(searchQuery, 300);

  const handleBikeSelect = (bike: Bike) => {
    console.log('QuickBikeBlockDialog: Велосипед выбран:', bike);
    setSelectedBike(bike);
  };

  const handleActionComplete = () => {
    setSelectedBike(null);
    setSearchQuery('');
    onOpenChange(false);
  };

  const handleDialogClose = (open: boolean) => {
    if (!open) {
      setSelectedBike(null);
      setSearchQuery('');
    }
    onOpenChange(open);
  };

  return (
    <Dialog open={open} onOpenChange={handleDialogClose}>
      <DialogContent className="sm:max-w-[600px] max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle>Быстрая блокировка велосипеда</DialogTitle>
        </DialogHeader>
        
        <div className="flex-1 overflow-hidden flex flex-col space-y-4">
          <SearchInput 
            value={searchQuery}
            onChange={setSearchQuery}
            placeholder="Поиск по серийному номеру, GPS-тегу, модели, курьеру..."
          />
          
          {selectedBike ? (
            <BikeActionControls 
              bike={selectedBike}
              onBack={() => setSelectedBike(null)}
              onActionComplete={handleActionComplete}
            />
          ) : debouncedQuery ? (
            <SearchResults 
              searchQuery={debouncedQuery}
              onBikeSelect={handleBikeSelect}
            />
          ) : (
            <div className="flex items-center justify-center py-8 text-muted-foreground">
              Введите запрос для поиска велосипеда
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
